export const put = (key, value) => {
  window.sessionStorage.setItem(key, value);
};
export const get = key => window.sessionStorage.getItem(key);
export const remove = key => window.sessionStorage.removeItem(key);
export const clear = () => {
  window.sessionStorage.clear();
};

export const safePut = (key, value) => {
  put(key, JSON.stringify(value));
};

export const safeGet = key => {
  try {
    return JSON.parse(get(key));
  } catch (e) {
    console.warn('unable to get for key: ' + key, e);
  }
};
